export default function FormatDate({date = 'fail', format = 'fail'}) {
    if(date == 'fail' || format === 'fail'){
        finalDate = 'Error en el paso de props';
    }
    const meses = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio",
        "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
    const [datePart, timePart] = date.split('T');
    const [year, month, day] = datePart.split('-');
    const dateObj = new Date(year, month - 1, day);

    const dayOfMonth = dateObj.getDate();
    const monthName = meses[dateObj.getMonth()];
    const fullYear = dateObj.getFullYear();

    // const formattedHours = dateObj.getHours().toString().padStart(2, '0');
    
    let finalDate = 'Sin información';

    if(format === 'y'){
        finalDate = fullYear;
    }
    if(format === 'm'){
        finalDate = monthName;
    }
    if(format === 's') {
        finalDate = `${dayOfMonth} de ${monthName}`;
    }
    if(format === 'l') {
        finalDate = `${monthName} de ${fullYear}`;
    }
    if(format === 'xl') {
        finalDate = `${dayOfMonth} de ${monthName} de ${fullYear}`;
    }
    return (
        <span>{finalDate}</span>
    );
}